import { getFiltersCount } from '@folio/stripes-acq-components';
import { useClaims } from '../../../../hooks';
import { buildClaimingQuery } from '../../search';
export var useClaiming = function (_a) {
    var filters = _a.filters, sorting = _a.sorting, pagination = _a.pagination, tenantId = _a.tenantId;
    var filtersCount = getFiltersCount(filters);
    var query = buildClaimingQuery(filters, sorting);
    var data = useClaims({
        limit: pagination.limit,
        offset: pagination.offset,
        query: query,
    }, {
        breakWithDefaults: !filtersCount,
        keepPreviousData: true,
        tenantId: tenantId,
    });
    return data;
};
